import { IApplicationState } from '../../types/redux';

export function isRenterFormEnabled(state: IApplicationState) {
  return state.isRenterFormEnabled;
}
